import { Progress } from '@agro-club/frontend-shared'
import { useEffect, useState } from 'react'
import { CertainGetItem, ItemsByIdsHook, ListGetItem } from './createItemsByIdsOnceHook'

export function createItemsByIdsHook<ItemType>(
  isMultipleIdsRequest: true,
  getItem: ListGetItem<ItemType>,
): ItemsByIdsHook<ItemType>
export function createItemsByIdsHook<ItemType>(
  isMultipleIdsRequest: false,
  getItem: CertainGetItem<ItemType>,
): ItemsByIdsHook<ItemType>

/*
 * Creates hook that fetches items by given ids once (on mount)
 * @param isMultipleIdsRequest - is getItem request can fetch array of ids?
 * @param getItem - item(s) request
 * @param dictSelector - optional, selector to dictionary of items that will be fetched, if not in there
 * @returns [Progress, ItemType]
 */
export function createItemsByIdsHook<ItemType>(
  isMultipleIdsRequest: boolean,
  getItem: CertainGetItem<ItemType> | ListGetItem<ItemType>,
) {
  return (ids: string[]) => {
    const [progress, setProgress] = useState(Progress.IDLE)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const [items, setItems] = useState<ItemType[]>([])

    useEffect(() => {
      if (ids.length) {
        setProgress(Progress.WORK)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error seems like ts bug because if isMultipleIdsRequest === true getItem arg IS array of strings
        const promise = isMultipleIdsRequest ? getItem(ids) : Promise.all(ids.map((id) => getItem(id)))

        promise
          .then((response) => setItems(response.data || response))
          .catch(() => {
            setProgress(Progress.ERROR)
          })
          .finally(() => {
            setProgress(Progress.SUCCESS)
          })
      }
    }, [ids])

    return [progress, items]
  }
}
